"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontFamily = exports.font = void 0;
var _styledComponents = require("styled-components");
var _constants = require("../constants");
var fontFamily = exports.fontFamily = (0, _styledComponents.css)(["font-family:", ",", ";"], function (_ref) {
  var $font = _ref.$font;
  return $font;
}, _constants.FALLBACK_FONT);
var font = exports.font = (0, _styledComponents.css)(["", " color:", ";> svg{path{fill:", ";}}"], fontFamily, function (_ref2) {
  var $color = _ref2.$color;
  return $color;
}, function (_ref3) {
  var $color = _ref3.$color;
  return $color;
});